import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { checkNetworkType } from "./NetworkUtils";
import { AR_MARKUP_VIEW, EXTRACT_TEXT_VIEW, MARKUP_VIEW } from "../../constants/Constants";

const DeviceNetwork = () => {
    const { isRemoteParticipantJoined, expandView, nqAvailable } = useSelector((state) => state.commonReducer);
    const { networkUnstableMessage, isNetworkUnstablePopupVisible } = useSelector((state) => state.batteryNetworkInfo);
    const { extractTextInprogress } = useSelector((state) => state.extractText);
    const { markupInprogress, arMarkupLiveStream, markupLiveStream } = useSelector((state) => state.markup);

    useEffect(() => {
        /* register lister for network connection change */
        if (navigator.connection != undefined && isRemoteParticipantJoined) {
            navigator.connection.addEventListener("change", function () {
                checkNetworkType("onchange");
            });
        }

        return () => {
            if (navigator.connection != undefined && isRemoteParticipantJoined) {
                navigator.connection.removeEventListener("change", function () {
                    checkNetworkType("onchange");
                });
            }
        };
    }, [isRemoteParticipantJoined]);

    /* check if internet unstable view will be shown or not */
    const checkIsNetworkUnstablePopupVisible = () => {
        return (
            isRemoteParticipantJoined &&
            isNetworkUnstablePopupVisible &&
            expandView &&
            nqAvailable &&
            markupInprogress === MARKUP_VIEW.OFF_VIEW &&
            arMarkupLiveStream === AR_MARKUP_VIEW.OFF_VIEW &&
            extractTextInprogress === EXTRACT_TEXT_VIEW.OFF_VIEW &&
            !markupLiveStream
        );
    };

    return (
        // <-- Internet Unstable Popup -->
        <>
            {checkIsNetworkUnstablePopupVisible() && (
                <div className='device-notification'>
                    <div className='device-notification-box'>
                        <div className='device-notification-in'>
                            <div className='device-notification-icon'>
                                <span className='for-icon icon-network'></span>
                            </div>
                            <div className='device-notification-text'>{networkUnstableMessage}</div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default DeviceNetwork;
